import logos from './assets/logos';
import logosSmall from './assets/logos-small';

export default {
    unkwnown: {logo: logos.unknown, logoSmall: logosSmall.unknown},
    '0B': {logo: logos['0B'], logoSmall: logosSmall['0B']},
    '0E': {logo: logos['0E'], logoSmall: logosSmall['0E']},
    '0Q': {logo: logos['0Q'], logoSmall: logosSmall['0Q']},
    '0V': {logo: logos['0V'], logoSmall: logosSmall['0V']},
    '01': {logo: logos['01'], logoSmall: logosSmall['01']},
    '1A': {logo: logos['1A'], logoSmall: logosSmall['1A']},
    '1B': {logo: logos['1B'], logoSmall: logosSmall['1B']},
    '1C': {logo: logos['1C'], logoSmall: logosSmall['1C']},
    '1D': {logo: logos['1D'], logoSmall: logosSmall['1D']},
    '1E': {logo: logos['1E'], logoSmall: logosSmall['1E']},
    '1F': {logo: logos['1F'], logoSmall: logosSmall['1F']},
    '1G': {logo: logos['1G'], logoSmall: logosSmall['1G']},
    '1H': {logo: logos['1H'], logoSmall: logosSmall['1H']},
    '1I': {logo: logos['1I'], logoSmall: logosSmall['1I']},
    '1J': {logo: logos['1J'], logoSmall: logosSmall['1J']},
    '1K': {logo: logos['1K'], logoSmall: logosSmall['1K']},
    '1L': {logo: logos['1L'], logoSmall: logosSmall['1L']},
    '1M': {logo: logos['1M'], logoSmall: logosSmall['1M']},
    '1N': {logo: logos['1N'], logoSmall: logosSmall['1N']},
    '1P': {logo: logos['1P'], logoSmall: logosSmall['1P']},
    '1Q': {logo: logos['1Q'], logoSmall: logosSmall['1Q']},
    '1R': {logo: logos['1R'], logoSmall: logosSmall['1R']},
    '1S': {logo: logos['1S'], logoSmall: logosSmall['1S']},
    '1T': {logo: logos['1T'], logoSmall: logosSmall['1T']},
    '1U': {logo: logos['1U'], logoSmall: logosSmall['1U']},
    '1X': {logo: logos['1X'], logoSmall: logosSmall['1X']},
    '1Y': {logo: logos['1Y'], logoSmall: logosSmall['1Y']},
    '1Z': {logo: logos['1Z'], logoSmall: logosSmall['1Z']},
    '02': {logo: logos['02'], logoSmall: logosSmall['02']},
    '2A': {logo: logos['2A'], logoSmall: logosSmall['2A']},
    '2B': {logo: logos['2B'], logoSmall: logosSmall['2B']},
    '2C': {logo: logos['2C'], logoSmall: logosSmall['2C']},
    '2D': {logo: logos['2D'], logoSmall: logosSmall['2D']},
    '2E': {logo: logos['2E'], logoSmall: logosSmall['2E']},
    '2F': {logo: logos['2F'], logoSmall: logosSmall['2F']},
    '2G': {logo: logos['2G'], logoSmall: logosSmall['2G']},
    '2H': {logo: logos['2H'], logoSmall: logosSmall['2H']},
    '2I': {logo: logos['2I'], logoSmall: logosSmall['2I']},
    '2J': {logo: logos['2J'], logoSmall: logosSmall['2J']},
    '2K': {logo: logos['2K'], logoSmall: logosSmall['2K']},
    '2L': {logo: logos['2L'], logoSmall: logosSmall['2L']},
    '2M': {logo: logos['2M'], logoSmall: logosSmall['2M']},
    '2N': {logo: logos['2N'], logoSmall: logosSmall['2N']},
    '2O': {logo: logos['2O'], logoSmall: logosSmall['2O']},
    '2P': {logo: logos['2P'], logoSmall: logosSmall['2P']},
    '2Q': {logo: logos['2Q'], logoSmall: logosSmall['2Q']},
    '2R': {logo: logos['2R'], logoSmall: logosSmall['2R']},
    '2S': {logo: logos['2S'], logoSmall: logosSmall['2S']},
    '2T': {logo: logos['2T'], logoSmall: logosSmall['2T']},
    '2U': {logo: logos['2U'], logoSmall: logosSmall['2U']},
    '2V': {logo: logos['2V'], logoSmall: logosSmall['2V']},
    '2W': {logo: logos['2W'], logoSmall: logosSmall['2W']},
    '2Y': {logo: logos['2Y'], logoSmall: logosSmall['2Y']},
    '2Z': {logo: logos['2Z'], logoSmall: logosSmall['2Z']},
    '3A': {logo: logos['3A'], logoSmall: logosSmall['3A']},
    '3B': {logo: logos['3B'], logoSmall: logosSmall['3B']},
    '3C': {logo: logos['3C'], logoSmall: logosSmall['3C']},
    '3D': {logo: logos['3D'], logoSmall: logosSmall['3D']},
    '3E': {logo: logos['3E'], logoSmall: logosSmall['3E']},
    '3F': {logo: logos['3F'], logoSmall: logosSmall['3F']},
    '3G': {logo: logos['3G'], logoSmall: logosSmall['3G']},
    '3H': {logo: logos['3H'], logoSmall: logosSmall['3H']},
    '3I': {logo: logos['3I'], logoSmall: logosSmall['3I']},
    '3J': {logo: logos['3J'], logoSmall: logosSmall['3J']},
    '3K': {logo: logos['3K'], logoSmall: logosSmall['3K']},
    '3L': {logo: logos['3L'], logoSmall: logosSmall['3L']},
    '3M': {logo: logos['3M'], logoSmall: logosSmall['3M']},
    '3N': {logo: logos['3N'], logoSmall: logosSmall['3N']},
    '3O': {logo: logos['3O'], logoSmall: logosSmall['3O']},
    '3P': {logo: logos['3P'], logoSmall: logosSmall['3P']},
    '3Q': {logo: logos['3Q'], logoSmall: logosSmall['3Q']},
    '3R': {logo: logos['3R'], logoSmall: logosSmall['3R']},
    '3S': {logo: logos['3S'], logoSmall: logosSmall['3S']},
    '3T': {logo: logos['3T'], logoSmall: logosSmall['3T']},
    '3U': {logo: logos['3U'], logoSmall: logosSmall['3U']},
    '3V': {logo: logos['3V'], logoSmall: logosSmall['3V']},
    '3W': {logo: logos['3W'], logoSmall: logosSmall['3W']},
    '3X': {logo: logos['3X'], logoSmall: logosSmall['3X']},
    '3Y': {logo: logos['3Y'], logoSmall: logosSmall['3Y']},
    '3Z': {logo: logos['3Z'], logoSmall: logosSmall['3Z']},
    '04': {logo: logos['04'], logoSmall: logosSmall['04']},
    '4A': {logo: logos['4A'], logoSmall: logosSmall['4A']},
    '4B': {logo: logos['4B'], logoSmall: logosSmall['4B']},
    '4C': {logo: logos['4C'], logoSmall: logosSmall['4C']},
    '4D': {logo: logos['4D'], logoSmall: logosSmall['4D']},
    '4E': {logo: logos['4E'], logoSmall: logosSmall['4E']},
    '4G': {logo: logos['4G'], logoSmall: logosSmall['4G']},
    '4H': {logo: logos['4H'], logoSmall: logosSmall['4H']},
    '4I': {logo: logos['4I'], logoSmall: logosSmall['4I']},
    '4J': {logo: logos['4J'], logoSmall: logosSmall['4J']},
    '4K': {logo: logos['4K'], logoSmall: logosSmall['4K']},
    '4L': {logo: logos['4L'], logoSmall: logosSmall['4L']},
    '4M': {logo: logos['4M'], logoSmall: logosSmall['4M']},
    '4N': {logo: logos['4N'], logoSmall: logosSmall['4N']},
    '4O': {logo: logos['4O'], logoSmall: logosSmall['4O']},
    '4P': {logo: logos['4P'], logoSmall: logosSmall['4P']},
    '4Q': {logo: logos['4Q'], logoSmall: logosSmall['4Q']},
    '4R': {logo: logos['4R'], logoSmall: logosSmall['4R']},
    '4T': {logo: logos['4T'], logoSmall: logosSmall['4T']},
    '4U': {logo: logos['4U'], logoSmall: logosSmall['4U']},
    '4V': {logo: logos['4V'], logoSmall: logosSmall['4V']},
    '4W': {logo: logos['4W'], logoSmall: logosSmall['4W']},
    '4X': {logo: logos['4X'], logoSmall: logosSmall['4X']},
    '4Y': {logo: logos['4Y'], logoSmall: logosSmall['4Y']},
    '4Z': {logo: logos['4Z'], logoSmall: logosSmall['4Z']},
    '5A': {logo: logos['5A'], logoSmall: logosSmall['5A']},
    '5B': {logo: logos['5B'], logoSmall: logosSmall['5B']},
    '5C': {logo: logos['5C'], logoSmall: logosSmall['5C']},
    '5D': {logo: logos['5D'], logoSmall: logosSmall['5D']},
    '5E': {logo: logos['5E'], logoSmall: logosSmall['5E']},
    '5F': {logo: logos['5F'], logoSmall: logosSmall['5F']},
    '5G': {logo: logos['5G'], logoSmall: logosSmall['5G']},
    '5H': {logo: logos['5H'], logoSmall: logosSmall['5H']},
    '5I': {logo: logos['5I'], logoSmall: logosSmall['5I']},
    '5J': {logo: logos['5J'], logoSmall: logosSmall['5J']},
    '5K': {logo: logos['5K'], logoSmall: logosSmall['5K']},
    '5L': {logo: logos['5L'], logoSmall: logosSmall['5L']},
    '5M': {logo: logos['5M'], logoSmall: logosSmall['5M']},
    '5N': {logo: logos['5N'], logoSmall: logosSmall['5N']},
    '5O': {logo: logos['5O'], logoSmall: logosSmall['5O']},
    '5P': {logo: logos['5P'], logoSmall: logosSmall['5P']},
    '5Q': {logo: logos['5Q'], logoSmall: logosSmall['5Q']},
    '5R': {logo: logos['5R'], logoSmall: logosSmall['5R']},
    '5S': {logo: logos['5S'], logoSmall: logosSmall['5S']},
    '5T': {logo: logos['5T'], logoSmall: logosSmall['5T']},
    '5U': {logo: logos['5U'], logoSmall: logosSmall['5U']},
    '5V': {logo: logos['5V'], logoSmall: logosSmall['5V']},
    '5W': {logo: logos['5W'], logoSmall: logosSmall['5W']},
    '5X': {logo: logos['5X'], logoSmall: logosSmall['5X']},
    '5Y': {logo: logos['5Y'], logoSmall: logosSmall['5Y']},
    '5Z': {logo: logos['5Z'], logoSmall: logosSmall['5Z']},
    '6A': {logo: logos['6A'], logoSmall: logosSmall['6A']},
    '6B': {logo: logos['6B'], logoSmall: logosSmall['6B']},
    '6C': {logo: logos['6C'], logoSmall: logosSmall['6C']},
    '6D': {logo: logos['6D'], logoSmall: logosSmall['6D']},
    '6E': {logo: logos['6E'], logoSmall: logosSmall['6E']},
    '6F': {logo: logos['6F'], logoSmall: logosSmall['6F']},
    '6G': {logo: logos['6G'], logoSmall: logosSmall['6G']},
    '6H': {logo: logos['6H'], logoSmall: logosSmall['6H']},
    '6I': {logo: logos['6I'], logoSmall: logosSmall['6I']},
    '6J': {logo: logos['6J'], logoSmall: logosSmall['6J']},
    '6K': {logo: logos['6K'], logoSmall: logosSmall['6K']},
    '6L': {logo: logos['6L'], logoSmall: logosSmall['6L']},
    '6M': {logo: logos['6M'], logoSmall: logosSmall['6M']},
    '6N': {logo: logos['6N'], logoSmall: logosSmall['6N']},
    '6O': {logo: logos['6O'], logoSmall: logosSmall['6O']},
    '6P': {logo: logos['6P'], logoSmall: logosSmall['6P']},
    '6Q': {logo: logos['6Q'], logoSmall: logosSmall['6Q']},
    '6R': {logo: logos['6R'], logoSmall: logosSmall['6R']},
    '6S': {logo: logos['6S'], logoSmall: logosSmall['6S']},
    '6T': {logo: logos['6T'], logoSmall: logosSmall['6T']},
    '6U': {logo: logos['6U'], logoSmall: logosSmall['6U']},
    '6V': {logo: logos['6V'], logoSmall: logosSmall['6V']},
    '6W': {logo: logos['6W'], logoSmall: logosSmall['6W']},
    '6X': {logo: logos['6X'], logoSmall: logosSmall['6X']},
    '6Y': {logo: logos['6Y'], logoSmall: logosSmall['6Y']},
    '6Z': {logo: logos['6Z'], logoSmall: logosSmall['6Z']},
    '7A': {logo: logos['7A'], logoSmall: logosSmall['7A']},
    '7B': {logo: logos['7B'], logoSmall: logosSmall['7B']},
    '7C': {logo: logos['7C'], logoSmall: logosSmall['7C']},
    '7D': {logo: logos['7D'], logoSmall: logosSmall['7D']},
    '7E': {logo: logos['7E'], logoSmall: logosSmall['7E']},
    '7F': {logo: logos['7F'], logoSmall: logosSmall['7F']},
    '7G': {logo: logos['7G'], logoSmall: logosSmall['7G']},
    '7H': {logo: logos['7H'], logoSmall: logosSmall['7H']},
    '7I': {logo: logos['7I'], logoSmall: logosSmall['7I']},
    '7J': {logo: logos['7J'], logoSmall: logosSmall['7J']},
    '7K': {logo: logos['7K'], logoSmall: logosSmall['7K']},
    '7L': {logo: logos['7L'], logoSmall: logosSmall['7L']},
    '7M': {logo: logos['7M'], logoSmall: logosSmall['7M']},
    '7N': {logo: logos['7N'], logoSmall: logosSmall['7N']},
    '7O': {logo: logos['7O'], logoSmall: logosSmall['7O']},
    '7P': {logo: logos['7P'], logoSmall: logosSmall['7P']},
    '7Q': {logo: logos['7Q'], logoSmall: logosSmall['7Q']},
    '7R': {logo: logos['7R'], logoSmall: logosSmall['7R']},
    '7T': {logo: logos['7T'], logoSmall: logosSmall['7T']},
    '7U': {logo: logos['7U'], logoSmall: logosSmall['7U']},
    '7V': {logo: logos['7V'], logoSmall: logosSmall['7V']},
    '7W': {logo: logos['7W'], logoSmall: logosSmall['7W']},
    '7Y': {logo: logos['7Y'], logoSmall: logosSmall['7Y']},
    '7Z': {logo: logos['7Z'], logoSmall: logosSmall['7Z']},
    '8A': {logo: logos['8A'], logoSmall: logosSmall['8A']},
    '8B': {logo: logos['8B'], logoSmall: logosSmall['8B']},
    '8C': {logo: logos['8C'], logoSmall: logosSmall['8C']},
    '8D': {logo: logos['8D'], logoSmall: logosSmall['8D']},
    '8E': {logo: logos['8E'], logoSmall: logosSmall['8E']},
    '8F': {logo: logos['8F'], logoSmall: logosSmall['8F']},
    '8G': {logo: logos['8G'], logoSmall: logosSmall['8G']},
    '8H': {logo: logos['8H'], logoSmall: logosSmall['8H']},
    '8I': {logo: logos['8I'], logoSmall: logosSmall['8I']},
    '8J': {logo: logos['8J'], logoSmall: logosSmall['8J']},
    '8K': {logo: logos['8K'], logoSmall: logosSmall['8K']},
    '8L': {logo: logos['8L'], logoSmall: logosSmall['8L']},
    '8M': {logo: logos['8M'], logoSmall: logosSmall['8M']},
    '8N': {logo: logos['8N'], logoSmall: logosSmall['8N']},
    '8O': {logo: logos['8O'], logoSmall: logosSmall['8O']},
    '8P': {logo: logos['8P'], logoSmall: logosSmall['8P']},
    '8Q': {logo: logos['8Q'], logoSmall: logosSmall['8Q']},
    '8R': {logo: logos['8R'], logoSmall: logosSmall['8R']},
    '8S': {logo: logos['8S'], logoSmall: logosSmall['8S']},
    '8T': {logo: logos['8T'], logoSmall: logosSmall['8T']},
    '8U': {logo: logos['8U'], logoSmall: logosSmall['8U']},
    '8V': {logo: logos['8V'], logoSmall: logosSmall['8V']},
    '8W': {logo: logos['8W'], logoSmall: logosSmall['8W']},
    '8Y': {logo: logos['8Y'], logoSmall: logosSmall['8Y']},
    '8Z': {logo: logos['8Z'], logoSmall: logosSmall['8Z']},
    '9A': {logo: logos['9A'], logoSmall: logosSmall['9A']},
    '9B': {logo: logos['9B'], logoSmall: logosSmall['9B']},
    '9C': {logo: logos['9C'], logoSmall: logosSmall['9C']},
    '9D': {logo: logos['9D'], logoSmall: logosSmall['9D']},
    '9E': {logo: logos['9E'], logoSmall: logosSmall['9E']},
    '9F': {logo: logos['9F'], logoSmall: logosSmall['9F']},
    '9G': {logo: logos['9G'], logoSmall: logosSmall['9G']},
    '9H': {logo: logos['9H'], logoSmall: logosSmall['9H']},
    '9I': {logo: logos['9I'], logoSmall: logosSmall['9I']},
    '9J': {logo: logos['9J'], logoSmall: logosSmall['9J']},
    '9K': {logo: logos['9K'], logoSmall: logosSmall['9K']},
    '9L': {logo: logos['9L'], logoSmall: logosSmall['9L']},
    '9M': {logo: logos['9M'], logoSmall: logosSmall['9M']},
    '9N': {logo: logos['9N'], logoSmall: logosSmall['9N']},
    '9O': {logo: logos['9O'], logoSmall: logosSmall['9O']},
    '9P': {logo: logos['9P'], logoSmall: logosSmall['9P']},
    '9Q': {logo: logos['9Q'], logoSmall: logosSmall['9Q']},
    '9R': {logo: logos['9R'], logoSmall: logosSmall['9R']},
    '9S': {logo: logos['9S'], logoSmall: logosSmall['9S']},
    '9T': {logo: logos['9T'], logoSmall: logosSmall['9T']},
    '9U': {logo: logos['9U'], logoSmall: logosSmall['9U']},
    '9V': {logo: logos['9V'], logoSmall: logosSmall['9V']},
    '9W': {logo: logos['9W'], logoSmall: logosSmall['9W']},
    '9X': {logo: logos['9X'], logoSmall: logosSmall['9X']},
    '9Y': {logo: logos['9Y'], logoSmall: logosSmall['9Y']},
    A0: {logo: logos.A0, logoSmall: logosSmall.A0},
    A1: {logo: logos.A1, logoSmall: logosSmall.A1},
    A2: {logo: logos.A2, logoSmall: logosSmall.A2},
    A3: {logo: logos.A3, logoSmall: logosSmall.A3},
    A4: {logo: logos.A4, logoSmall: logosSmall.A4},
    A5: {logo: logos.A5, logoSmall: logosSmall.A5},
    A6: {logo: logos.A6, logoSmall: logosSmall.A6},
    A7: {logo: logos.A7, logoSmall: logosSmall.A7},
    A8: {logo: logos.A8, logoSmall: logosSmall.A8},
    A9: {logo: logos.A9, logoSmall: logosSmall.A9},
    AA: {logo: logos.AA, logoSmall: logosSmall.AA},
    AB: {logo: logos.AB, logoSmall: logosSmall.AB},
    AC: {logo: logos.AC, logoSmall: logosSmall.AC},
    AD: {logo: logos.AD, logoSmall: logosSmall.AD},
    AE: {logo: logos.AE, logoSmall: logosSmall.AE},
    AF: {logo: logos.AF, logoSmall: logosSmall.AF},
    AG: {logo: logos.AG, logoSmall: logosSmall.AG},
    AH: {logo: logos.AH, logoSmall: logosSmall.AH},
    AI: {logo: logos.AI, logoSmall: logosSmall.AI},
    AJ: {logo: logos.AJ, logoSmall: logosSmall.AJ},
    AK: {logo: logos.AK, logoSmall: logosSmall.AK},
    AL: {logo: logos.AL, logoSmall: logosSmall.AL},
    AM: {logo: logos.AM, logoSmall: logosSmall.AM},
    AN: {logo: logos.AN, logoSmall: logosSmall.AN},
    AO: {logo: logos.AO, logoSmall: logosSmall.AO},
    AP: {logo: logos.AP, logoSmall: logosSmall.AP},
    AQ: {logo: logos.AQ, logoSmall: logosSmall.AQ},
    AR: {logo: logos.AR, logoSmall: logosSmall.AR},
    AS: {logo: logos.AS, logoSmall: logosSmall.AS},
    AT: {logo: logos.AT, logoSmall: logosSmall.AT},
    AU: {logo: logos.AU, logoSmall: logosSmall.AU},
    AV: {logo: logos.AV, logoSmall: logosSmall.AV},
    AW: {logo: logos.AW, logoSmall: logosSmall.AW},
    AX: {logo: logos.AX, logoSmall: logosSmall.AX},
    AY: {logo: logos.AY, logoSmall: logosSmall.AY},
    AZ: {logo: logos.AZ, logoSmall: logosSmall.AZ},
    B0: {logo: logos.B0, logoSmall: logosSmall.B0},
    B2: {logo: logos.B2, logoSmall: logosSmall.B2},
    B3: {logo: logos.B3, logoSmall: logosSmall.B3},
    B4: {logo: logos.B4, logoSmall: logosSmall.B4},
    B5: {logo: logos.B5, logoSmall: logosSmall.B5},
    B6: {logo: logos.B6, logoSmall: logosSmall.B6},
    B7: {logo: logos.B7, logoSmall: logosSmall.B7},
    B8: {logo: logos.B8, logoSmall: logosSmall.B8},
    B9: {logo: logos.B9, logoSmall: logosSmall.B9},
    BA: {logo: logos.BA, logoSmall: logosSmall.BA},
    BB: {logo: logos.BB, logoSmall: logosSmall.BB},
    BC: {logo: logos.BC, logoSmall: logosSmall.BC},
    BD: {logo: logos.BD, logoSmall: logosSmall.BD},
    BE: {logo: logos.BE, logoSmall: logosSmall.BE},
    BF: {logo: logos.BF, logoSmall: logosSmall.BF},
    BG: {logo: logos.BG, logoSmall: logosSmall.BG},
    BH: {logo: logos.BH, logoSmall: logosSmall.BH},
    BI: {logo: logos.BI, logoSmall: logosSmall.BI},
    BJ: {logo: logos.BJ, logoSmall: logosSmall.BJ},
    BK: {logo: logos.BK, logoSmall: logosSmall.BK},
    BL: {logo: logos.BL, logoSmall: logosSmall.BL},
    BM: {logo: logos.BM, logoSmall: logosSmall.BM},
    BN: {logo: logos.BN, logoSmall: logosSmall.BN},
    BO: {logo: logos.BO, logoSmall: logosSmall.BO},
    BP: {logo: logos.BP, logoSmall: logosSmall.BP},
    BQ: {logo: logos.BQ, logoSmall: logosSmall.BQ},
    BR: {logo: logos.BR, logoSmall: logosSmall.BR},
    BS: {logo: logos.BS, logoSmall: logosSmall.BS},
    BT: {logo: logos.BT, logoSmall: logosSmall.BT},
    BU: {logo: logos.BU, logoSmall: logosSmall.BU},
    BV: {logo: logos.BV, logoSmall: logosSmall.BV},
    BW: {logo: logos.BW, logoSmall: logosSmall.BW},
    BX: {logo: logos.BX, logoSmall: logosSmall.BX},
    BY: {logo: logos.BY, logoSmall: logosSmall.BY},
    BZ: {logo: logos.BZ, logoSmall: logosSmall.BZ},
    C0: {logo: logos.C0, logoSmall: logosSmall.C0},
    C2: {logo: logos.C2, logoSmall: logosSmall.C2},
    C3: {logo: logos.C3, logoSmall: logosSmall.C3},
    C4: {logo: logos.C4, logoSmall: logosSmall.C4},
    C5: {logo: logos.C5, logoSmall: logosSmall.C5},
    C6: {logo: logos.C6, logoSmall: logosSmall.C6},
    C7: {logo: logos.C7, logoSmall: logosSmall.C7},
    C8: {logo: logos.C8, logoSmall: logosSmall.C8},
    C9: {logo: logos.C9, logoSmall: logosSmall.C9},
    CA: {logo: logos.CA, logoSmall: logosSmall.CA},
    CB: {logo: logos.CB, logoSmall: logosSmall.CB},
    CC: {logo: logos.CC, logoSmall: logosSmall.CC},
    CD: {logo: logos.CD, logoSmall: logosSmall.CD},
    CE: {logo: logos.CE, logoSmall: logosSmall.CE},
    CF: {logo: logos.CF, logoSmall: logosSmall.CF},
    CG: {logo: logos.CG, logoSmall: logosSmall.CG},
    CH: {logo: logos.CH, logoSmall: logosSmall.CH},
    CI: {logo: logos.CI, logoSmall: logosSmall.CI},
    CJ: {logo: logos.CJ, logoSmall: logosSmall.CJ},
    CK: {logo: logos.CK, logoSmall: logosSmall.CK},
    CL: {logo: logos.CL, logoSmall: logosSmall.CL},
    CM: {logo: logos.CM, logoSmall: logosSmall.CM},
    CN: {logo: logos.CN, logoSmall: logosSmall.CN},
    CO: {logo: logos.CO, logoSmall: logosSmall.CO},
    CP: {logo: logos.CP, logoSmall: logosSmall.CP},
    CQ: {logo: logos.CQ, logoSmall: logosSmall.CQ},
    CR: {logo: logos.CR, logoSmall: logosSmall.CR},
    CS: {logo: logos.CS, logoSmall: logosSmall.CS},
    CT: {logo: logos.CT, logoSmall: logosSmall.CT},
    CU: {logo: logos.CU, logoSmall: logosSmall.CU},
    CV: {logo: logos.CV, logoSmall: logosSmall.CV},
    CW: {logo: logos.CW, logoSmall: logosSmall.CW},
    CX: {logo: logos.CX, logoSmall: logosSmall.CX},
    CY: {logo: logos.CY, logoSmall: logosSmall.CY},
    CZ: {logo: logos.CZ, logoSmall: logosSmall.CZ},
    D0: {logo: logos.D0, logoSmall: logosSmall.D0},
    D1: {logo: logos.D1, logoSmall: logosSmall.D1},
    D2: {logo: logos.D2, logoSmall: logosSmall.D2},
    D3: {logo: logos.D3, logoSmall: logosSmall.D3},
    D4: {logo: logos.D4, logoSmall: logosSmall.D4},
    D5: {logo: logos.D5, logoSmall: logosSmall.D5},
    D6: {logo: logos.D6, logoSmall: logosSmall.D6},
    D7: {logo: logos.D7, logoSmall: logosSmall.D7},
    D8: {logo: logos.D8, logoSmall: logosSmall.D8},
    D9: {logo: logos.D9, logoSmall: logosSmall.D9},
    DA: {logo: logos.DA, logoSmall: logosSmall.DA},
    DB: {logo: logos.DB, logoSmall: logosSmall.DB},
    DC: {logo: logos.DC, logoSmall: logosSmall.DC},
    DD: {logo: logos.DD, logoSmall: logosSmall.DD},
    DE: {logo: logos.DE, logoSmall: logosSmall.DE},
    DF: {logo: logos.DF, logoSmall: logosSmall.DF},
    DG: {logo: logos.DG, logoSmall: logosSmall.DG},
    DH: {logo: logos.DH, logoSmall: logosSmall.DH},
    DI: {logo: logos.DI, logoSmall: logosSmall.DI},
    DJ: {logo: logos.DJ, logoSmall: logosSmall.DJ},
    DK: {logo: logos.DK, logoSmall: logosSmall.DK},
    DL: {logo: logos.DL, logoSmall: logosSmall.DL},
    DM: {logo: logos.DM, logoSmall: logosSmall.DM},
    DN: {logo: logos.DN, logoSmall: logosSmall.DN},
    DO: {logo: logos.DO, logoSmall: logosSmall.DO},
    DP: {logo: logos.DP, logoSmall: logosSmall.DP},
    DQ: {logo: logos.DQ, logoSmall: logosSmall.DQ},
    DR: {logo: logos.DR, logoSmall: logosSmall.DR},
    DS: {logo: logos.DS, logoSmall: logosSmall.DS},
    DT: {logo: logos.DT, logoSmall: logosSmall.DT},
    DU: {logo: logos.DU, logoSmall: logosSmall.DU},
    DV: {logo: logos.DV, logoSmall: logosSmall.DV},
    DW: {logo: logos.DW, logoSmall: logosSmall.DW},
    DX: {logo: logos.DX, logoSmall: logosSmall.DX},
    DY: {logo: logos.DY, logoSmall: logosSmall.DY},
    DZ: {logo: logos.DZ, logoSmall: logosSmall.DZ},
    E0: {logo: logos.E0, logoSmall: logosSmall.E0},
    E2: {logo: logos.E2, logoSmall: logosSmall.E2},
    E3: {logo: logos.E3, logoSmall: logosSmall.E3},
    E4: {logo: logos.E4, logoSmall: logosSmall.E4},
    E5: {logo: logos.E5, logoSmall: logosSmall.E5},
    E6: {logo: logos.E6, logoSmall: logosSmall.E6},
    E7: {logo: logos.E7, logoSmall: logosSmall.E7},
    E8: {logo: logos.E8, logoSmall: logosSmall.E8},
    E9: {logo: logos.E9, logoSmall: logosSmall.E9},
    EA: {logo: logos.EA, logoSmall: logosSmall.EA},
    EB: {logo: logos.EB, logoSmall: logosSmall.EB},
    EC: {logo: logos.EC, logoSmall: logosSmall.EC},
    ED: {logo: logos.ED, logoSmall: logosSmall.ED},
    EE: {logo: logos.EE, logoSmall: logosSmall.EE},
    EF: {logo: logos.EF, logoSmall: logosSmall.EF},
    EG: {logo: logos.EG, logoSmall: logosSmall.EG},
    EH: {logo: logos.EH, logoSmall: logosSmall.EH},
    EI: {logo: logos.EI, logoSmall: logosSmall.EI},
    EJ: {logo: logos.EJ, logoSmall: logosSmall.EJ},
    EK: {logo: logos.EK, logoSmall: logosSmall.EK},
    EL: {logo: logos.EL, logoSmall: logosSmall.EL},
    EM: {logo: logos.EM, logoSmall: logosSmall.EM},
    EN: {logo: logos.EN, logoSmall: logosSmall.EN},
    EO: {logo: logos.EO, logoSmall: logosSmall.EO},
    EP: {logo: logos.EP, logoSmall: logosSmall.EP},
    EQ: {logo: logos.EQ, logoSmall: logosSmall.EQ},
    ER: {logo: logos.ER, logoSmall: logosSmall.ER},
    ES: {logo: logos.ES, logoSmall: logosSmall.ES},
    ET: {logo: logos.ET, logoSmall: logosSmall.ET},
    EU: {logo: logos.EU, logoSmall: logosSmall.EU},
    EV: {logo: logos.EV, logoSmall: logosSmall.EV},
    EW: {logo: logos.EW, logoSmall: logosSmall.EW},
    EX: {logo: logos.EX, logoSmall: logosSmall.EX},
    EY: {logo: logos.EY, logoSmall: logosSmall.EY},
    EZ: {logo: logos.EZ, logoSmall: logosSmall.EZ},
    F2: {logo: logos.F2, logoSmall: logosSmall.F2},
    F3: {logo: logos.F3, logoSmall: logosSmall.F3},
    F4: {logo: logos.F4, logoSmall: logosSmall.F4},
    F5: {logo: logos.F5, logoSmall: logosSmall.F5},
    F6: {logo: logos.F6, logoSmall: logosSmall.F6},
    F7: {logo: logos.F7, logoSmall: logosSmall.F7},
    F8: {logo: logos.F8, logoSmall: logosSmall.F8},
    F9: {logo: logos.F9, logoSmall: logosSmall.F9},
    FA: {logo: logos.FA, logoSmall: logosSmall.FA},
    FB: {logo: logos.FB, logoSmall: logosSmall.FB},
    FC: {logo: logos.FC, logoSmall: logosSmall.FC},
    FD: {logo: logos.FD, logoSmall: logosSmall.FD},
    FE: {logo: logos.FE, logoSmall: logosSmall.FE},
    FG: {logo: logos.FG, logoSmall: logosSmall.FG},
    FH: {logo: logos.FH, logoSmall: logosSmall.FH},
    FI: {logo: logos.FI, logoSmall: logosSmall.FI},
    FJ: {logo: logos.FJ, logoSmall: logosSmall.FJ},
    FK: {logo: logos.FK, logoSmall: logosSmall.FK},
    FL: {logo: logos.FL, logoSmall: logosSmall.FL},
    FM: {logo: logos.FM, logoSmall: logosSmall.FM},
    FN: {logo: logos.FN, logoSmall: logosSmall.FN},
    FO: {logo: logos.FO, logoSmall: logosSmall.FO},
    FP: {logo: logos.FP, logoSmall: logosSmall.FP},
    FQ: {logo: logos.FQ, logoSmall: logosSmall.FQ},
    FR: {logo: logos.FR, logoSmall: logosSmall.FR},
    FS: {logo: logos.FS, logoSmall: logosSmall.FS},
    FT: {logo: logos.FT, logoSmall: logosSmall.FT},
    FU: {logo: logos.FU, logoSmall: logosSmall.FU},
    FV: {logo: logos.FV, logoSmall: logosSmall.FV},
    FW: {logo: logos.FW, logoSmall: logosSmall.FW},
    FX: {logo: logos.FX, logoSmall: logosSmall.FX},
    FY: {logo: logos.FY, logoSmall: logosSmall.FY},
    FZ: {logo: logos.FZ, logoSmall: logosSmall.FZ},
    G0: {logo: logos.G0, logoSmall: logosSmall.G0},
    G1: {logo: logos.G1, logoSmall: logosSmall.G1},
    G2: {logo: logos.G2, logoSmall: logosSmall.G2},
    G3: {logo: logos.G3, logoSmall: logosSmall.G3},
    G4: {logo: logos.G4, logoSmall: logosSmall.G4},
    G5: {logo: logos.G5, logoSmall: logosSmall.G5},
    G6: {logo: logos.G6, logoSmall: logosSmall.G6},
    G7: {logo: logos.G7, logoSmall: logosSmall.G7},
    G8: {logo: logos.G8, logoSmall: logosSmall.G8},
    G9: {logo: logos.G9, logoSmall: logosSmall.G9},
    GA: {logo: logos.GA, logoSmall: logosSmall.GA},
    GB: {logo: logos.GB, logoSmall: logosSmall.GB},
    GC: {logo: logos.GC, logoSmall: logosSmall.GC},
    GD: {logo: logos.GD, logoSmall: logosSmall.GD},
    GE: {logo: logos.GE, logoSmall: logosSmall.GE},
    GF: {logo: logos.GF, logoSmall: logosSmall.GF},
    GG: {logo: logos.GG, logoSmall: logosSmall.GG},
    GH: {logo: logos.GH, logoSmall: logosSmall.GH},
    GI: {logo: logos.GI, logoSmall: logosSmall.GI},
    GJ: {logo: logos.GJ, logoSmall: logosSmall.GJ},
    GK: {logo: logos.GK, logoSmall: logosSmall.GK},
    GL: {logo: logos.GL, logoSmall: logosSmall.GL},
    GM: {logo: logos.GM, logoSmall: logosSmall.GM},
    GN: {logo: logos.GN, logoSmall: logosSmall.GN},
    GO: {logo: logos.GO, logoSmall: logosSmall.GO},
    GP: {logo: logos.GP, logoSmall: logosSmall.GP},
    GQ: {logo: logos.GQ, logoSmall: logosSmall.GQ},
    GR: {logo: logos.GR, logoSmall: logosSmall.GR},
    GS: {logo: logos.GS, logoSmall: logosSmall.GS},
    GT: {logo: logos.GT, logoSmall: logosSmall.GT},
    GU: {logo: logos.GU, logoSmall: logosSmall.GU},
    GV: {logo: logos.GV, logoSmall: logosSmall.GV},
    GW: {logo: logos.GW, logoSmall: logosSmall.GW},
    GX: {logo: logos.GX, logoSmall: logosSmall.GX},
    GY: {logo: logos.GY, logoSmall: logosSmall.GY},
    GZ: {logo: logos.GZ, logoSmall: logosSmall.GZ},
    H1: {logo: logos.H1, logoSmall: logosSmall.H1},
    H2: {logo: logos.H2, logoSmall: logosSmall.H2},
    H3: {logo: logos.H3, logoSmall: logosSmall.H3},
    H4: {logo: logos.H4, logoSmall: logosSmall.H4},
    H5: {logo: logos.H5, logoSmall: logosSmall.H5},
    H6: {logo: logos.H6, logoSmall: logosSmall.H6},
    H7: {logo: logos.H7, logoSmall: logosSmall.H7},
    H8: {logo: logos.H8, logoSmall: logosSmall.H8},
    H9: {logo: logos.H9, logoSmall: logosSmall.H9},
    HA: {logo: logos.HA, logoSmall: logosSmall.HA},
    HB: {logo: logos.HB, logoSmall: logosSmall.HB},
    HC: {logo: logos.HC, logoSmall: logosSmall.HC},
    HD: {logo: logos.HD, logoSmall: logosSmall.HD},
    HE: {logo: logos.HE, logoSmall: logosSmall.HE},
    HF: {logo: logos.HF, logoSmall: logosSmall.HF},
    HG: {logo: logos.HG, logoSmall: logosSmall.HG},
    HH: {logo: logos.HH, logoSmall: logosSmall.HH},
    HI: {logo: logos.HI, logoSmall: logosSmall.HI},
    HJ: {logo: logos.HJ, logoSmall: logosSmall.HJ},
    HK: {logo: logos.HK, logoSmall: logosSmall.HK},
    HM: {logo: logos.HM, logoSmall: logosSmall.HM},
    HN: {logo: logos.HN, logoSmall: logosSmall.HN},
    HO: {logo: logos.HO, logoSmall: logosSmall.HO},
    HP: {logo: logos.HP, logoSmall: logosSmall.HP},
    HQ: {logo: logos.HQ, logoSmall: logosSmall.HQ},
    HR: {logo: logos.HR, logoSmall: logosSmall.HR},
    HS: {logo: logos.HS, logoSmall: logosSmall.HS},
    HT: {logo: logos.HT, logoSmall: logosSmall.HT},
    HU: {logo: logos.HU, logoSmall: logosSmall.HU},
    HV: {logo: logos.HV, logoSmall: logosSmall.HV},
    HW: {logo: logos.HW, logoSmall: logosSmall.HW},
    HX: {logo: logos.HX, logoSmall: logosSmall.HX},
    HY: {logo: logos.HY, logoSmall: logosSmall.HY},
    HZ: {logo: logos.HZ, logoSmall: logosSmall.HZ},
    I1: {logo: logos.I1, logoSmall: logosSmall.I1},
    I2: {logo: logos.I2, logoSmall: logosSmall.I2},
    I3: {logo: logos.I3, logoSmall: logosSmall.I3},
    I4: {logo: logos.I4, logoSmall: logosSmall.I4},
    I5: {logo: logos.I5, logoSmall: logosSmall.I5},
    I6: {logo: logos.I6, logoSmall: logosSmall.I6},
    I7: {logo: logos.I7, logoSmall: logosSmall.I7},
    I8: {logo: logos.I8, logoSmall: logosSmall.I8},
    I9: {logo: logos.I9, logoSmall: logosSmall.I9},
    IA: {logo: logos.IA, logoSmall: logosSmall.IA},
    IB: {logo: logos.IB, logoSmall: logosSmall.IB},
    IC: {logo: logos.IC, logoSmall: logosSmall.IC},
    ID: {logo: logos.ID, logoSmall: logosSmall.ID},
    IE: {logo: logos.IE, logoSmall: logosSmall.IE},
    IF: {logo: logos.IF, logoSmall: logosSmall.IF},
    IG: {logo: logos.IG, logoSmall: logosSmall.IG},
    IH: {logo: logos.IH, logoSmall: logosSmall.IH},
    II: {logo: logos.II, logoSmall: logosSmall.II},
    IJ: {logo: logos.IJ, logoSmall: logosSmall.IJ},
    IK: {logo: logos.IK, logoSmall: logosSmall.IK},
    IL: {logo: logos.IL, logoSmall: logosSmall.IL},
    IM: {logo: logos.IM, logoSmall: logosSmall.IM},
    IN: {logo: logos.IN, logoSmall: logosSmall.IN},
    IO: {logo: logos.IO, logoSmall: logosSmall.IO},
    IP: {logo: logos.IP, logoSmall: logosSmall.IP},
    IQ: {logo: logos.IQ, logoSmall: logosSmall.IQ},
    IR: {logo: logos.IR, logoSmall: logosSmall.IR},
    IS: {logo: logos.IS, logoSmall: logosSmall.IS},
    IT: {logo: logos.IT, logoSmall: logosSmall.IT},
    IU: {logo: logos.IU, logoSmall: logosSmall.IU},
    IV: {logo: logos.IV, logoSmall: logosSmall.IV},
    IW: {logo: logos.IW, logoSmall: logosSmall.IW},
    IX: {logo: logos.IX, logoSmall: logosSmall.IX},
    IY: {logo: logos.IY, logoSmall: logosSmall.IY},
    IZ: {logo: logos.IZ, logoSmall: logosSmall.IZ},
    J0: {logo: logos.J0, logoSmall: logosSmall.J0},
    J1: {logo: logos.J1, logoSmall: logosSmall.J1},
    J2: {logo: logos.J2, logoSmall: logosSmall.J2},
    J3: {logo: logos.J3, logoSmall: logosSmall.J3},
    J4: {logo: logos.J4, logoSmall: logosSmall.J4},
    J5: {logo: logos.J5, logoSmall: logosSmall.J5},
    J6: {logo: logos.J6, logoSmall: logosSmall.J6},
    J7: {logo: logos.J7, logoSmall: logosSmall.J7},
    J8: {logo: logos.J8, logoSmall: logosSmall.J8},
    J9: {logo: logos.J9, logoSmall: logosSmall.J9},
    JA: {logo: logos.JA, logoSmall: logosSmall.JA},
    JB: {logo: logos.JB, logoSmall: logosSmall.JB},
    JC: {logo: logos.JC, logoSmall: logosSmall.JC},
    JD: {logo: logos.JD, logoSmall: logosSmall.JD},
    JE: {logo: logos.JE, logoSmall: logosSmall.JE},
    JF: {logo: logos.JF, logoSmall: logosSmall.JF},
    JG: {logo: logos.JG, logoSmall: logosSmall.JG},
    JH: {logo: logos.JH, logoSmall: logosSmall.JH},
    JI: {logo: logos.JI, logoSmall: logosSmall.JI},
    JJ: {logo: logos.JJ, logoSmall: logosSmall.JJ},
    JK: {logo: logos.JK, logoSmall: logosSmall.JK},
    JL: {logo: logos.JL, logoSmall: logosSmall.JL},
    JM: {logo: logos.JM, logoSmall: logosSmall.JM},
    JN: {logo: logos.JN, logoSmall: logosSmall.JN},
    JO: {logo: logos.JO, logoSmall: logosSmall.JO},
    JP: {logo: logos.JP, logoSmall: logosSmall.JP},
    JQ: {logo: logos.JQ, logoSmall: logosSmall.JQ},
    JR: {logo: logos.JR, logoSmall: logosSmall.JR},
    JS: {logo: logos.JS, logoSmall: logosSmall.JS},
    JT: {logo: logos.JT, logoSmall: logosSmall.JT},
    JU: {logo: logos.JU, logoSmall: logosSmall.JU},
    JV: {logo: logos.JV, logoSmall: logosSmall.JV},
    JW: {logo: logos.JW, logoSmall: logosSmall.JW},
    JX: {logo: logos.JX, logoSmall: logosSmall.JX},
    JY: {logo: logos.JY, logoSmall: logosSmall.JY},
    JZ: {logo: logos.JZ, logoSmall: logosSmall.JZ},
    K1: {logo: logos.K1, logoSmall: logosSmall.K1},
    K2: {logo: logos.K2, logoSmall: logosSmall.K2},
    K3: {logo: logos.K3, logoSmall: logosSmall.K3},
    K4: {logo: logos.K4, logoSmall: logosSmall.K4},
    K5: {logo: logos.K5, logoSmall: logosSmall.K5},
    K6: {logo: logos.K6, logoSmall: logosSmall.K6},
    K7: {logo: logos.K7, logoSmall: logosSmall.K7},
    K8: {logo: logos.K8, logoSmall: logosSmall.K8},
    K9: {logo: logos.K9, logoSmall: logosSmall.K9},
    KA: {logo: logos.KA, logoSmall: logosSmall.KA},
    KB: {logo: logos.KB, logoSmall: logosSmall.KB},
    KC: {logo: logos.KC, logoSmall: logosSmall.KC},
    KD: {logo: logos.KD, logoSmall: logosSmall.KD},
    KE: {logo: logos.KE, logoSmall: logosSmall.KE},
    KF: {logo: logos.KF, logoSmall: logosSmall.KF},
    KG: {logo: logos.KG, logoSmall: logosSmall.KG},
    KH: {logo: logos.KH, logoSmall: logosSmall.KH},
    KI: {logo: logos.KI, logoSmall: logosSmall.KI},
    KJ: {logo: logos.KJ, logoSmall: logosSmall.KJ},
    KK: {logo: logos.KK, logoSmall: logosSmall.KK},
    KL: {logo: logos.KL, logoSmall: logosSmall.KL},
    KM: {logo: logos.KM, logoSmall: logosSmall.KM},
    KN: {logo: logos.KN, logoSmall: logosSmall.KN},
    KO: {logo: logos.KO, logoSmall: logosSmall.KO},
    KP: {logo: logos.KP, logoSmall: logosSmall.KP},
    KQ: {logo: logos.KQ, logoSmall: logosSmall.KQ},
    KR: {logo: logos.KR, logoSmall: logosSmall.KR},
    KS: {logo: logos.KS, logoSmall: logosSmall.KS},
    KT: {logo: logos.KT, logoSmall: logosSmall.KT},
    KU: {logo: logos.KU, logoSmall: logosSmall.KU},
    KV: {logo: logos.KV, logoSmall: logosSmall.KV},
    KW: {logo: logos.KW, logoSmall: logosSmall.KW},
    KX: {logo: logos.KX, logoSmall: logosSmall.KX},
    KY: {logo: logos.KY, logoSmall: logosSmall.KY},
    KZ: {logo: logos.KZ, logoSmall: logosSmall.KZ},
    L2: {logo: logos.L2, logoSmall: logosSmall.L2},
    L3: {logo: logos.L3, logoSmall: logosSmall.L3},
    L4: {logo: logos.L4, logoSmall: logosSmall.L4},
    L5: {logo: logos.L5, logoSmall: logosSmall.L5},
    L6: {logo: logos.L6, logoSmall: logosSmall.L6},
    L7: {logo: logos.L7, logoSmall: logosSmall.L7},
    L8: {logo: logos.L8, logoSmall: logosSmall.L8},
    L9: {logo: logos.L9, logoSmall: logosSmall.L9},
    LA: {logo: logos.LA, logoSmall: logosSmall.LA},
    LB: {logo: logos.LB, logoSmall: logosSmall.LB},
    LC: {logo: logos.LC, logoSmall: logosSmall.LC},
    LD: {logo: logos.LD, logoSmall: logosSmall.LD},
    LE: {logo: logos.LE, logoSmall: logosSmall.LE},
    LF: {logo: logos.LF, logoSmall: logosSmall.LF},
    LG: {logo: logos.LG, logoSmall: logosSmall.LG},
    LH: {logo: logos.LH, logoSmall: logosSmall.LH},
    LI: {logo: logos.LI, logoSmall: logosSmall.LI},
    LJ: {logo: logos.LJ, logoSmall: logosSmall.LJ},
    LK: {logo: logos.LK, logoSmall: logosSmall.LK},
    LL: {logo: logos.LL, logoSmall: logosSmall.LL},
    LM: {logo: logos.LM, logoSmall: logosSmall.LM},
    LN: {logo: logos.LN, logoSmall: logosSmall.LN},
    LO: {logo: logos.LO, logoSmall: logosSmall.LO},
    LP: {logo: logos.LP, logoSmall: logosSmall.LP},
    LQ: {logo: logos.LQ, logoSmall: logosSmall.LQ},
    LR: {logo: logos.LR, logoSmall: logosSmall.LR},
    LS: {logo: logos.LS, logoSmall: logosSmall.LS},
    LT: {logo: logos.LT, logoSmall: logosSmall.LT},
    LU: {logo: logos.LU, logoSmall: logosSmall.LU},
    LV: {logo: logos.LV, logoSmall: logosSmall.LV},
    LW: {logo: logos.LW, logoSmall: logosSmall.LW},
    LX: {logo: logos.LX, logoSmall: logosSmall.LX},
    LY: {logo: logos.LY, logoSmall: logosSmall.LY},
    LZ: {logo: logos.LZ, logoSmall: logosSmall.LZ},
    M0: {logo: logos.M0, logoSmall: logosSmall.M0},
    M2: {logo: logos.M2, logoSmall: logosSmall.M2},
    M3: {logo: logos.M3, logoSmall: logosSmall.M3},
    M4: {logo: logos.M4, logoSmall: logosSmall.M4},
    M5: {logo: logos.M5, logoSmall: logosSmall.M5},
    M6: {logo: logos.M6, logoSmall: logosSmall.M6},
    M7: {logo: logos.M7, logoSmall: logosSmall.M7},
    M8: {logo: logos.M8, logoSmall: logosSmall.M8},
    M9: {logo: logos.M9, logoSmall: logosSmall.M9},
    MA: {logo: logos.MA, logoSmall: logosSmall.MA},
    MB: {logo: logos.MB, logoSmall: logosSmall.MB},
    MC: {logo: logos.MC, logoSmall: logosSmall.MC},
    MD: {logo: logos.MD, logoSmall: logosSmall.MD},
    ME: {logo: logos.ME, logoSmall: logosSmall.ME},
    MF: {logo: logos.MF, logoSmall: logosSmall.MF},
    MG: {logo: logos.MG, logoSmall: logosSmall.MG},
    MH: {logo: logos.MH, logoSmall: logosSmall.MH},
    MI: {logo: logos.MI, logoSmall: logosSmall.MI},
    MJ: {logo: logos.MJ, logoSmall: logosSmall.MJ},
    MK: {logo: logos.MK, logoSmall: logosSmall.MK},
    ML: {logo: logos.ML, logoSmall: logosSmall.ML},
    MM: {logo: logos.MM, logoSmall: logosSmall.MM},
    MN: {logo: logos.MN, logoSmall: logosSmall.MN},
    MO: {logo: logos.MO, logoSmall: logosSmall.MO},
    MP: {logo: logos.MP, logoSmall: logosSmall.MP},
    MQ: {logo: logos.MQ, logoSmall: logosSmall.MQ},
    MR: {logo: logos.MR, logoSmall: logosSmall.MR},
    MS: {logo: logos.MS, logoSmall: logosSmall.MS},
    MT: {logo: logos.MT, logoSmall: logosSmall.MT},
    MU: {logo: logos.MU, logoSmall: logosSmall.MU},
    MV: {logo: logos.MV, logoSmall: logosSmall.MV},
    MW: {logo: logos.MW, logoSmall: logosSmall.MW},
    MX: {logo: logos.MX, logoSmall: logosSmall.MX},
    MY: {logo: logos.MY, logoSmall: logosSmall.MY},
    MZ: {logo: logos.MZ, logoSmall: logosSmall.MZ},
    N2: {logo: logos.N2, logoSmall: logosSmall.N2},
    N3: {logo: logos.N3, logoSmall: logosSmall.N3},
    N4: {logo: logos.N4, logoSmall: logosSmall.N4},
    N5: {logo: logos.N5, logoSmall: logosSmall.N5},
    N6: {logo: logos.N6, logoSmall: logosSmall.N6},
    N7: {logo: logos.N7, logoSmall: logosSmall.N7},
    N8: {logo: logos.N8, logoSmall: logosSmall.N8},
    N9: {logo: logos.N9, logoSmall: logosSmall.N9},
    NA: {logo: logos.NA, logoSmall: logosSmall.NA},
    NB: {logo: logos.NB, logoSmall: logosSmall.NB},
    NC: {logo: logos.NC, logoSmall: logosSmall.NC},
    NE: {logo: logos.NE, logoSmall: logosSmall.NE},
    NF: {logo: logos.NF, logoSmall: logosSmall.NF},
    NG: {logo: logos.NG, logoSmall: logosSmall.NG},
    NH: {logo: logos.NH, logoSmall: logosSmall.NH},
    NI: {logo: logos.NI, logoSmall: logosSmall.NI},
    NK: {logo: logos.NK, logoSmall: logosSmall.NK},
    NL: {logo: logos.NL, logoSmall: logosSmall.NL},
    NM: {logo: logos.NM, logoSmall: logosSmall.NM},
    NN: {logo: logos.NN, logoSmall: logosSmall.NN},
    NO: {logo: logos.NO, logoSmall: logosSmall.NO},
    NP: {logo: logos.NP, logoSmall: logosSmall.NP},
    NQ: {logo: logos.NQ, logoSmall: logosSmall.NQ},
    NR: {logo: logos.NR, logoSmall: logosSmall.NR},
    NS: {logo: logos.NS, logoSmall: logosSmall.NS},
    NT: {logo: logos.NT, logoSmall: logosSmall.NT},
    NU: {logo: logos.NU, logoSmall: logosSmall.NU},
    NV: {logo: logos.NV, logoSmall: logosSmall.NV},
    NW: {logo: logos.NW, logoSmall: logosSmall.NW},
    NX: {logo: logos.NX, logoSmall: logosSmall.NX},
    NY: {logo: logos.NY, logoSmall: logosSmall.NY},
    NZ: {logo: logos.NZ, logoSmall: logosSmall.NZ},
    O2: {logo: logos.O2, logoSmall: logosSmall.O2},
    O3: {logo: logos.O3, logoSmall: logosSmall.O3},
    O4: {logo: logos.O4, logoSmall: logosSmall.O4},
    O5: {logo: logos.O5, logoSmall: logosSmall.O5},
    O6: {logo: logos.O6, logoSmall: logosSmall.O6},
    O7: {logo: logos.O7, logoSmall: logosSmall.O7},
    O8: {logo: logos.O8, logoSmall: logosSmall.O8},
    O9: {logo: logos.O9, logoSmall: logosSmall.O9},
    OA: {logo: logos.OA, logoSmall: logosSmall.OA},
    OB: {logo: logos.OB, logoSmall: logosSmall.OB},
    OC: {logo: logos.OC, logoSmall: logosSmall.OC},
    OD: {logo: logos.OD, logoSmall: logosSmall.OD},
    OE: {logo: logos.OE, logoSmall: logosSmall.OE},
    OF: {logo: logos.OF, logoSmall: logosSmall.OF},
    OG: {logo: logos.OG, logoSmall: logosSmall.OG},
    OH: {logo: logos.OH, logoSmall: logosSmall.OH},
    OI: {logo: logos.OI, logoSmall: logosSmall.OI},
    OJ: {logo: logos.OJ, logoSmall: logosSmall.OJ},
    OK: {logo: logos.OK, logoSmall: logosSmall.OK},
    OL: {logo: logos.OL, logoSmall: logosSmall.OL},
    OM: {logo: logos.OM, logoSmall: logosSmall.OM},
    ON: {logo: logos.ON, logoSmall: logosSmall.ON},
    OO: {logo: logos.OO, logoSmall: logosSmall.OO},
    OP: {logo: logos.OP, logoSmall: logosSmall.OP},
    OQ: {logo: logos.OQ, logoSmall: logosSmall.OQ},
    OR: {logo: logos.OR, logoSmall: logosSmall.OR},
    OS: {logo: logos.OS, logoSmall: logosSmall.OS},
    OT: {logo: logos.OT, logoSmall: logosSmall.OT},
    OU: {logo: logos.OU, logoSmall: logosSmall.OU},
    OV: {logo: logos.OV, logoSmall: logosSmall.OV},
    OW: {logo: logos.OW, logoSmall: logosSmall.OW},
    OX: {logo: logos.OX, logoSmall: logosSmall.OX},
    OY: {logo: logos.OY, logoSmall: logosSmall.OY},
    OZ: {logo: logos.OZ, logoSmall: logosSmall.OZ},
    P0: {logo: logos.P0, logoSmall: logosSmall.P0},
    P1: {logo: logos.P1, logoSmall: logosSmall.P1},
    P2: {logo: logos.P2, logoSmall: logosSmall.P2},
    P3: {logo: logos.P3, logoSmall: logosSmall.P3},
    P4: {logo: logos.P4, logoSmall: logosSmall.P4},
    P5: {logo: logos.P5, logoSmall: logosSmall.P5},
    P6: {logo: logos.P6, logoSmall: logosSmall.P6},
    P7: {logo: logos.P7, logoSmall: logosSmall.P7},
    P8: {logo: logos.P8, logoSmall: logosSmall.P8},
    P9: {logo: logos.P9, logoSmall: logosSmall.P9},
    PA: {logo: logos.PA, logoSmall: logosSmall.PA},
    PB: {logo: logos.PB, logoSmall: logosSmall.PB},
    PC: {logo: logos.PC, logoSmall: logosSmall.PC},
    PD: {logo: logos.PD, logoSmall: logosSmall.PD},
    PE: {logo: logos.PE, logoSmall: logosSmall.PE},
    PF: {logo: logos.PF, logoSmall: logosSmall.PF},
    PG: {logo: logos.PG, logoSmall: logosSmall.PG},
    PH: {logo: logos.PH, logoSmall: logosSmall.PH},
    PI: {logo: logos.PI, logoSmall: logosSmall.PI},
    PJ: {logo: logos.PJ, logoSmall: logosSmall.PJ},
    PK: {logo: logos.PK, logoSmall: logosSmall.PK},
    PL: {logo: logos.PL, logoSmall: logosSmall.PL},
    PM: {logo: logos.PM, logoSmall: logosSmall.PM},
    PN: {logo: logos.PN, logoSmall: logosSmall.PN},
    PO: {logo: logos.PO, logoSmall: logosSmall.PO},
    PP: {logo: logos.PP, logoSmall: logosSmall.PP},
    PQ: {logo: logos.PQ, logoSmall: logosSmall.PQ},
    PR: {logo: logos.PR, logoSmall: logosSmall.PR},
    PS: {logo: logos.PS, logoSmall: logosSmall.PS},
    PT: {logo: logos.PT, logoSmall: logosSmall.PT},
    PU: {logo: logos.PU, logoSmall: logosSmall.PU},
    PV: {logo: logos.PV, logoSmall: logosSmall.PV},
    PW: {logo: logos.PW, logoSmall: logosSmall.PW},
    PX: {logo: logos.PX, logoSmall: logosSmall.PX},
    PY: {logo: logos.PY, logoSmall: logosSmall.PY},
    PZ: {logo: logos.PZ, logoSmall: logosSmall.PZ},
    Q0: {logo: logos.Q0, logoSmall: logosSmall.Q0},
    Q2: {logo: logos.Q2, logoSmall: logosSmall.Q2},
    Q3: {logo: logos.Q3, logoSmall: logosSmall.Q3},
    Q4: {logo: logos.Q4, logoSmall: logosSmall.Q4},
    Q5: {logo: logos.Q5, logoSmall: logosSmall.Q5},
    Q6: {logo: logos.Q6, logoSmall: logosSmall.Q6},
    Q7: {logo: logos.Q7, logoSmall: logosSmall.Q7},
    Q8: {logo: logos.Q8, logoSmall: logosSmall.Q8},
    Q9: {logo: logos.Q9, logoSmall: logosSmall.Q9},
    QA: {logo: logos.QA, logoSmall: logosSmall.QA},
    QB: {logo: logos.QB, logoSmall: logosSmall.QB},
    QC: {logo: logos.QC, logoSmall: logosSmall.QC},
    QD: {logo: logos.QD, logoSmall: logosSmall.QD},
    QE: {logo: logos.QE, logoSmall: logosSmall.QE},
    QF: {logo: logos.QF, logoSmall: logosSmall.QF},
    QG: {logo: logos.QG, logoSmall: logosSmall.QG},
    QH: {logo: logos.QH, logoSmall: logosSmall.QH},
    QI: {logo: logos.QI, logoSmall: logosSmall.QI},
    QJ: {logo: logos.QJ, logoSmall: logosSmall.QJ},
    QK: {logo: logos.QK, logoSmall: logosSmall.QK},
    QL: {logo: logos.QL, logoSmall: logosSmall.QL},
    QM: {logo: logos.QM, logoSmall: logosSmall.QM},
    QN: {logo: logos.QN, logoSmall: logosSmall.QN},
    QO: {logo: logos.QO, logoSmall: logosSmall.QO},
    QP: {logo: logos.QP, logoSmall: logosSmall.QP},
    QQ: {logo: logos.QQ, logoSmall: logosSmall.QQ},
    QR: {logo: logos.QR, logoSmall: logosSmall.QR},
    QS: {logo: logos.QS, logoSmall: logosSmall.QS},
    QT: {logo: logos.QT, logoSmall: logosSmall.QT},
    QU: {logo: logos.QU, logoSmall: logosSmall.QU},
    QV: {logo: logos.QV, logoSmall: logosSmall.QV},
    QW: {logo: logos.QW, logoSmall: logosSmall.QW},
    QX: {logo: logos.QX, logoSmall: logosSmall.QX},
    QY: {logo: logos.QY, logoSmall: logosSmall.QY},
    QZ: {logo: logos.QZ, logoSmall: logosSmall.QZ},
    R0: {logo: logos.R0, logoSmall: logosSmall.R0},
    R1: {logo: logos.R1, logoSmall: logosSmall.R1},
    R2: {logo: logos.R2, logoSmall: logosSmall.R2},
    R3: {logo: logos.R3, logoSmall: logosSmall.R3},
    R4: {logo: logos.R4, logoSmall: logosSmall.R4},
    R5: {logo: logos.R5, logoSmall: logosSmall.R5},
    R6: {logo: logos.R6, logoSmall: logosSmall.R6},
    R7: {logo: logos.R7, logoSmall: logosSmall.R7},
    R8: {logo: logos.R8, logoSmall: logosSmall.R8},
    R9: {logo: logos.R9, logoSmall: logosSmall.R9},
    RA: {logo: logos.RA, logoSmall: logosSmall.RA},
    RB: {logo: logos.RB, logoSmall: logosSmall.RB},
    RC: {logo: logos.RC, logoSmall: logosSmall.RC},
    RD: {logo: logos.RD, logoSmall: logosSmall.RD},
    RE: {logo: logos.RE, logoSmall: logosSmall.RE},
    RF: {logo: logos.RF, logoSmall: logosSmall.RF},
    RG: {logo: logos.RG, logoSmall: logosSmall.RG},
    RH: {logo: logos.RH, logoSmall: logosSmall.RH},
    RI: {logo: logos.RI, logoSmall: logosSmall.RI},
    RJ: {logo: logos.RJ, logoSmall: logosSmall.RJ},
    RK: {logo: logos.RK, logoSmall: logosSmall.RK},
    RL: {logo: logos.RL, logoSmall: logosSmall.RL},
    RN: {logo: logos.RN, logoSmall: logosSmall.RN},
    RO: {logo: logos.RO, logoSmall: logosSmall.RO},
    RP: {logo: logos.RP, logoSmall: logosSmall.RP},
    RQ: {logo: logos.RQ, logoSmall: logosSmall.RQ},
    RR: {logo: logos.RR, logoSmall: logosSmall.RR},
    RS: {logo: logos.RS, logoSmall: logosSmall.RS},
    RT: {logo: logos.RT, logoSmall: logosSmall.RT},
    RU: {logo: logos.RU, logoSmall: logosSmall.RU},
    RV: {logo: logos.RV, logoSmall: logosSmall.RV},
    RX: {logo: logos.RX, logoSmall: logosSmall.RX},
    RY: {logo: logos.RY, logoSmall: logosSmall.RY},
    RZ: {logo: logos.RZ, logoSmall: logosSmall.RZ},
    S0: {logo: logos.S0, logoSmall: logosSmall.S0},
    S1: {logo: logos.S1, logoSmall: logosSmall.S1},
    S2: {logo: logos.S2, logoSmall: logosSmall.S2},
    S3: {logo: logos.S3, logoSmall: logosSmall.S3},
    S4: {logo: logos.S4, logoSmall: logosSmall.S4},
    S5: {logo: logos.S5, logoSmall: logosSmall.S5},
    S6: {logo: logos.S6, logoSmall: logosSmall.S6},
    S7: {logo: logos.S7, logoSmall: logosSmall.S7},
    S8: {logo: logos.S8, logoSmall: logosSmall.S8},
    S9: {logo: logos.S9, logoSmall: logosSmall.S9},
    SA: {logo: logos.SA, logoSmall: logosSmall.SA},
    SB: {logo: logos.SB, logoSmall: logosSmall.SB},
    SC: {logo: logos.SC, logoSmall: logosSmall.SC},
    SD: {logo: logos.SD, logoSmall: logosSmall.SD},
    SE: {logo: logos.SE, logoSmall: logosSmall.SE},
    SF: {logo: logos.SF, logoSmall: logosSmall.SF},
    SG: {logo: logos.SG, logoSmall: logosSmall.SG},
    SH: {logo: logos.SH, logoSmall: logosSmall.SH},
    SI: {logo: logos.SI, logoSmall: logosSmall.SI},
    SJ: {logo: logos.SJ, logoSmall: logosSmall.SJ},
    SK: {logo: logos.SK, logoSmall: logosSmall.SK},
    SL: {logo: logos.SL, logoSmall: logosSmall.SL},
    SM: {logo: logos.SM, logoSmall: logosSmall.SM},
    SN: {logo: logos.SN, logoSmall: logosSmall.SN},
    SO: {logo: logos.SO, logoSmall: logosSmall.SO},
    SP: {logo: logos.SP, logoSmall: logosSmall.SP},
    SQ: {logo: logos.SQ, logoSmall: logosSmall.SQ},
    SR: {logo: logos.SR, logoSmall: logosSmall.SR},
    SS: {logo: logos.SS, logoSmall: logosSmall.SS},
    ST: {logo: logos.ST, logoSmall: logosSmall.ST},
    SU: {logo: logos.SU, logoSmall: logosSmall.SU},
    SV: {logo: logos.SV, logoSmall: logosSmall.SV},
    SW: {logo: logos.SW, logoSmall: logosSmall.SW},
    SX: {logo: logos.SX, logoSmall: logosSmall.SX},
    SY: {logo: logos.SY, logoSmall: logosSmall.SY},
    SZ: {logo: logos.SZ, logoSmall: logosSmall.SZ},
    T0: {logo: logos.T0, logoSmall: logosSmall.T0},
    T1: {logo: logos.T1, logoSmall: logosSmall.T1},
    T2: {logo: logos.T2, logoSmall: logosSmall.T2},
    T3: {logo: logos.T3, logoSmall: logosSmall.T3},
    T4: {logo: logos.T4, logoSmall: logosSmall.T4},
    T5: {logo: logos.T5, logoSmall: logosSmall.T5},
    T6: {logo: logos.T6, logoSmall: logosSmall.T6},
    T7: {logo: logos.T7, logoSmall: logosSmall.T7},
    T8: {logo: logos.T8, logoSmall: logosSmall.T8},
    TA: {logo: logos.TA, logoSmall: logosSmall.TA},
    TB: {logo: logos.TB, logoSmall: logosSmall.TB},
    TC: {logo: logos.TC, logoSmall: logosSmall.TC},
    TD: {logo: logos.TD, logoSmall: logosSmall.TD},
    TE: {logo: logos.TE, logoSmall: logosSmall.TE},
    TF: {logo: logos.TF, logoSmall: logosSmall.TF},
    TG: {logo: logos.TG, logoSmall: logosSmall.TG},
    TH: {logo: logos.TH, logoSmall: logosSmall.TH},
    TI: {logo: logos.TI, logoSmall: logosSmall.TI},
    TJ: {logo: logos.TJ, logoSmall: logosSmall.TJ},
    TK: {logo: logos.TK, logoSmall: logosSmall.TK},
    TL: {logo: logos.TL, logoSmall: logosSmall.TL},
    TM: {logo: logos.TM, logoSmall: logosSmall.TM},
    TN: {logo: logos.TN, logoSmall: logosSmall.TN},
    TO: {logo: logos.TO, logoSmall: logosSmall.TO},
    TP: {logo: logos.TP, logoSmall: logosSmall.TP},
    TQ: {logo: logos.TQ, logoSmall: logosSmall.TQ},
    TR: {logo: logos.TR, logoSmall: logosSmall.TR},
    TS: {logo: logos.TS, logoSmall: logosSmall.TS},
    TT: {logo: logos.TT, logoSmall: logosSmall.TT},
    TU: {logo: logos.TU, logoSmall: logosSmall.TU},
    TV: {logo: logos.TV, logoSmall: logosSmall.TV},
    TW: {logo: logos.TW, logoSmall: logosSmall.TW},
    TX: {logo: logos.TX, logoSmall: logosSmall.TX},
    TY: {logo: logos.TY, logoSmall: logosSmall.TY},
    TZ: {logo: logos.TZ, logoSmall: logosSmall.TZ},
    U0: {logo: logos.U0, logoSmall: logosSmall.U0},
    U2: {logo: logos.U2, logoSmall: logosSmall.U2},
    U3: {logo: logos.U3, logoSmall: logosSmall.U3},
    U4: {logo: logos.U4, logoSmall: logosSmall.U4},
    U5: {logo: logos.U5, logoSmall: logosSmall.U5},
    U6: {logo: logos.U6, logoSmall: logosSmall.U6},
    U7: {logo: logos.U7, logoSmall: logosSmall.U7},
    U8: {logo: logos.U8, logoSmall: logosSmall.U8},
    U9: {logo: logos.U9, logoSmall: logosSmall.U9},
    UA: {logo: logos.UA, logoSmall: logosSmall.UA},
    UB: {logo: logos.UB, logoSmall: logosSmall.UB},
    UC: {logo: logos.UC, logoSmall: logosSmall.UC},
    UD: {logo: logos.UD, logoSmall: logosSmall.UD},
    UE: {logo: logos.UE, logoSmall: logosSmall.UE},
    UF: {logo: logos.UF, logoSmall: logosSmall.UF},
    UG: {logo: logos.UG, logoSmall: logosSmall.UG},
    UH: {logo: logos.UH, logoSmall: logosSmall.UH},
    UI: {logo: logos.UI, logoSmall: logosSmall.UI},
    UJ: {logo: logos.UJ, logoSmall: logosSmall.UJ},
    UK: {logo: logos.UK, logoSmall: logosSmall.UK},
    UL: {logo: logos.UL, logoSmall: logosSmall.UL},
    UM: {logo: logos.UM, logoSmall: logosSmall.UM},
    UN: {logo: logos.UN, logoSmall: logosSmall.UN},
    UO: {logo: logos.UO, logoSmall: logosSmall.UO},
    UP: {logo: logos.UP, logoSmall: logosSmall.UP},
    UQ: {logo: logos.UQ, logoSmall: logosSmall.UQ},
    UR: {logo: logos.UR, logoSmall: logosSmall.UR},
    US: {logo: logos.US, logoSmall: logosSmall.US},
    UT: {logo: logos.UT, logoSmall: logosSmall.UT},
    UU: {logo: logos.UU, logoSmall: logosSmall.UU},
    UV: {logo: logos.UV, logoSmall: logosSmall.UV},
    UW: {logo: logos.UW, logoSmall: logosSmall.UW},
    UX: {logo: logos.UX, logoSmall: logosSmall.UX},
    UY: {logo: logos.UY, logoSmall: logosSmall.UY},
    UZ: {logo: logos.UZ, logoSmall: logosSmall.UZ},
    V0: {logo: logos.V0, logoSmall: logosSmall.V0},
    V2: {logo: logos.V2, logoSmall: logosSmall.V2},
    V3: {logo: logos.V3, logoSmall: logosSmall.V3},
    V4: {logo: logos.V4, logoSmall: logosSmall.V4},
    V5: {logo: logos.V5, logoSmall: logosSmall.V5},
    V6: {logo: logos.V6, logoSmall: logosSmall.V6},
    V7: {logo: logos.V7, logoSmall: logosSmall.V7},
    V8: {logo: logos.V8, logoSmall: logosSmall.V8},
    V9: {logo: logos.V9, logoSmall: logosSmall.V9},
    VA: {logo: logos.VA, logoSmall: logosSmall.VA},
    VB: {logo: logos.VB, logoSmall: logosSmall.VB},
    VC: {logo: logos.VC, logoSmall: logosSmall.VC},
    VD: {logo: logos.VD, logoSmall: logosSmall.VD},
    VE: {logo: logos.VE, logoSmall: logosSmall.VE},
    VF: {logo: logos.VF, logoSmall: logosSmall.VF},
    VG: {logo: logos.VG, logoSmall: logosSmall.VG},
    VH: {logo: logos.VH, logoSmall: logosSmall.VH},
    VI: {logo: logos.VI, logoSmall: logosSmall.VI},
    VJ: {logo: logos.VJ, logoSmall: logosSmall.VJ},
    VK: {logo: logos.VK, logoSmall: logosSmall.VK},
    VL: {logo: logos.VL, logoSmall: logosSmall.VL},
    VM: {logo: logos.VM, logoSmall: logosSmall.VM},
    VN: {logo: logos.VN, logoSmall: logosSmall.VN},
    VO: {logo: logos.VO, logoSmall: logosSmall.VO},
    VP: {logo: logos.VP, logoSmall: logosSmall.VP},
    VQ: {logo: logos.VQ, logoSmall: logosSmall.VQ},
    VR: {logo: logos.VR, logoSmall: logosSmall.VR},
    VS: {logo: logos.VS, logoSmall: logosSmall.VS},
    VT: {logo: logos.VT, logoSmall: logosSmall.VT},
    VU: {logo: logos.VU, logoSmall: logosSmall.VU},
    VV: {logo: logos.VV, logoSmall: logosSmall.VV},
    VW: {logo: logos.VW, logoSmall: logosSmall.VW},
    VX: {logo: logos.VX, logoSmall: logosSmall.VX},
    VY: {logo: logos.VY, logoSmall: logosSmall.VY},
    VZ: {logo: logos.VZ, logoSmall: logosSmall.VZ},
    W2: {logo: logos.W2, logoSmall: logosSmall.W2},
    W3: {logo: logos.W3, logoSmall: logosSmall.W3},
    W4: {logo: logos.W4, logoSmall: logosSmall.W4},
    W5: {logo: logos.W5, logoSmall: logosSmall.W5},
    W6: {logo: logos.W6, logoSmall: logosSmall.W6},
    W7: {logo: logos.W7, logoSmall: logosSmall.W7},
    W8: {logo: logos.W8, logoSmall: logosSmall.W8},
    W9: {logo: logos.W9, logoSmall: logosSmall.W9},
    WA: {logo: logos.WA, logoSmall: logosSmall.WA},
    WB: {logo: logos.WB, logoSmall: logosSmall.WB},
    WC: {logo: logos.WC, logoSmall: logosSmall.WC},
    WD: {logo: logos.WD, logoSmall: logosSmall.WD},
    WE: {logo: logos.WE, logoSmall: logosSmall.WE},
    WF: {logo: logos.WF, logoSmall: logosSmall.WF},
    WG: {logo: logos.WG, logoSmall: logosSmall.WG},
    WH: {logo: logos.WH, logoSmall: logosSmall.WH},
    WI: {logo: logos.WI, logoSmall: logosSmall.WI},
    WJ: {logo: logos.WJ, logoSmall: logosSmall.WJ},
    WK: {logo: logos.WK, logoSmall: logosSmall.WK},
    WL: {logo: logos.WL, logoSmall: logosSmall.WL},
    WM: {logo: logos.WM, logoSmall: logosSmall.WM},
    WN: {logo: logos.WN, logoSmall: logosSmall.WN},
    WO: {logo: logos.WO, logoSmall: logosSmall.WO},
    WP: {logo: logos.WP, logoSmall: logosSmall.WP},
    WQ: {logo: logos.WQ, logoSmall: logosSmall.WQ},
    WR: {logo: logos.WR, logoSmall: logosSmall.WR},
    WS: {logo: logos.WS, logoSmall: logosSmall.WS},
    WT: {logo: logos.WT, logoSmall: logosSmall.WT},
    WU: {logo: logos.WU, logoSmall: logosSmall.WU},
    WV: {logo: logos.WV, logoSmall: logosSmall.WV},
    WW: {logo: logos.WW, logoSmall: logosSmall.WW},
    WX: {logo: logos.WX, logoSmall: logosSmall.WX},
    WY: {logo: logos.WY, logoSmall: logosSmall.WY},
    WZ: {logo: logos.WZ, logoSmall: logosSmall.WZ},
    X0: {logo: logos.X0, logoSmall: logosSmall.X0},
    X1: {logo: logos.X1, logoSmall: logosSmall.X1},
    X2: {logo: logos.X2, logoSmall: logosSmall.X2},
    X3: {logo: logos.X3, logoSmall: logosSmall.X3},
    X4: {logo: logos.X4, logoSmall: logosSmall.X4},
    X5: {logo: logos.X5, logoSmall: logosSmall.X5},
    X6: {logo: logos.X6, logoSmall: logosSmall.X6},
    X7: {logo: logos.X7, logoSmall: logosSmall.X7},
    X8: {logo: logos.X8, logoSmall: logosSmall.X8},
    X9: {logo: logos.X9, logoSmall: logosSmall.X9},
    XA: {logo: logos.XA, logoSmall: logosSmall.XA},
    XB: {logo: logos.XB, logoSmall: logosSmall.XB},
    XC: {logo: logos.XC, logoSmall: logosSmall.XC},
    XD: {logo: logos.XD, logoSmall: logosSmall.XD},
    XE: {logo: logos.XE, logoSmall: logosSmall.XE},
    XF: {logo: logos.XF, logoSmall: logosSmall.XF},
    XG: {logo: logos.XG, logoSmall: logosSmall.XG},
    XH: {logo: logos.XH, logoSmall: logosSmall.XH},
    XI: {logo: logos.XI, logoSmall: logosSmall.XI},
    XJ: {logo: logos.XJ, logoSmall: logosSmall.XJ},
    XK: {logo: logos.XK, logoSmall: logosSmall.XK},
    XL: {logo: logos.XL, logoSmall: logosSmall.XL},
    XM: {logo: logos.XM, logoSmall: logosSmall.XM},
    XN: {logo: logos.XN, logoSmall: logosSmall.XN},
    XO: {logo: logos.XO, logoSmall: logosSmall.XO},
    XP: {logo: logos.XP, logoSmall: logosSmall.XP},
    XQ: {logo: logos.XQ, logoSmall: logosSmall.XQ},
    XR: {logo: logos.XR, logoSmall: logosSmall.XR},
    XS: {logo: logos.XS, logoSmall: logosSmall.XS},
    XT: {logo: logos.XT, logoSmall: logosSmall.XT},
    XU: {logo: logos.XU, logoSmall: logosSmall.XU},
    XV: {logo: logos.XV, logoSmall: logosSmall.XV},
    XW: {logo: logos.XW, logoSmall: logosSmall.XW},
    XX: {logo: logos.XX, logoSmall: logosSmall.XX},
    XY: {logo: logos.XY, logoSmall: logosSmall.XY},
    XZ: {logo: logos.XZ, logoSmall: logosSmall.XZ},
    Y0: {logo: logos.Y0, logoSmall: logosSmall.Y0},
    Y2: {logo: logos.Y2, logoSmall: logosSmall.Y2},
    Y4: {logo: logos.Y4, logoSmall: logosSmall.Y4},
    Y5: {logo: logos.Y5, logoSmall: logosSmall.Y5},
    Y6: {logo: logos.Y6, logoSmall: logosSmall.Y6},
    Y7: {logo: logos.Y7, logoSmall: logosSmall.Y7},
    Y8: {logo: logos.Y8, logoSmall: logosSmall.Y8},
    Y9: {logo: logos.Y9, logoSmall: logosSmall.Y9},
    YA: {logo: logos.YA, logoSmall: logosSmall.YA},
    YB: {logo: logos.YB, logoSmall: logosSmall.YB},
    YC: {logo: logos.YC, logoSmall: logosSmall.YC},
    YD: {logo: logos.YD, logoSmall: logosSmall.YD},
    YE: {logo: logos.YE, logoSmall: logosSmall.YE},
    YF: {logo: logos.YF, logoSmall: logosSmall.YF},
    YG: {logo: logos.YG, logoSmall: logosSmall.YG},
    YH: {logo: logos.YH, logoSmall: logosSmall.YH},
    YI: {logo: logos.YI, logoSmall: logosSmall.YI},
    YJ: {logo: logos.YJ, logoSmall: logosSmall.YJ},
    YK: {logo: logos.YK, logoSmall: logosSmall.YK},
    YL: {logo: logos.YL, logoSmall: logosSmall.YL},
    YM: {logo: logos.YM, logoSmall: logosSmall.YM},
    YN: {logo: logos.YN, logoSmall: logosSmall.YN},
    YO: {logo: logos.YO, logoSmall: logosSmall.YO},
    YP: {logo: logos.YP, logoSmall: logosSmall.YP},
    YQ: {logo: logos.YQ, logoSmall: logosSmall.YQ},
    YR: {logo: logos.YR, logoSmall: logosSmall.YR},
    YS: {logo: logos.YS, logoSmall: logosSmall.YS},
    YT: {logo: logos.YT, logoSmall: logosSmall.YT},
    YU: {logo: logos.YU, logoSmall: logosSmall.YU},
    YV: {logo: logos.YV, logoSmall: logosSmall.YV},
    YW: {logo: logos.YW, logoSmall: logosSmall.YW},
    YX: {logo: logos.YX, logoSmall: logosSmall.YX},
    YZ: {logo: logos.YZ, logoSmall: logosSmall.YZ},
    Z1: {logo: logos.Z1, logoSmall: logosSmall.Z1},
    Z2: {logo: logos.Z2, logoSmall: logosSmall.Z2},
    Z3: {logo: logos.Z3, logoSmall: logosSmall.Z3},
    Z4: {logo: logos.Z4, logoSmall: logosSmall.Z4},
    Z5: {logo: logos.Z5, logoSmall: logosSmall.Z5},
    Z6: {logo: logos.Z6, logoSmall: logosSmall.Z6},
    Z7: {logo: logos.Z7, logoSmall: logosSmall.Z7},
    Z8: {logo: logos.Z8, logoSmall: logosSmall.Z8},
    Z9: {logo: logos.Z9, logoSmall: logosSmall.Z9},
    ZA: {logo: logos.ZA, logoSmall: logosSmall.ZA},
    ZB: {logo: logos.ZB, logoSmall: logosSmall.ZB},
    ZC: {logo: logos.ZC, logoSmall: logosSmall.ZC},
    ZD: {logo: logos.ZD, logoSmall: logosSmall.ZD},
    ZE: {logo: logos.ZE, logoSmall: logosSmall.ZE},
    ZF: {logo: logos.ZF, logoSmall: logosSmall.ZF},
    ZG: {logo: logos.ZG, logoSmall: logosSmall.ZG},
    ZH: {logo: logos.ZH, logoSmall: logosSmall.ZH},
    ZI: {logo: logos.ZI, logoSmall: logosSmall.ZI},
    ZJ: {logo: logos.ZJ, logoSmall: logosSmall.ZJ},
    ZK: {logo: logos.ZK, logoSmall: logosSmall.ZK},
    ZL: {logo: logos.ZL, logoSmall: logosSmall.ZL},
    ZM: {logo: logos.ZM, logoSmall: logosSmall.ZM},
    ZN: {logo: logos.ZN, logoSmall: logosSmall.ZN},
    ZO: {logo: logos.ZO, logoSmall: logosSmall.ZO},
    ZP: {logo: logos.ZP, logoSmall: logosSmall.ZP},
    ZQ: {logo: logos.ZQ, logoSmall: logosSmall.ZQ},
    ZR: {logo: logos.ZR, logoSmall: logosSmall.ZR},
    ZS: {logo: logos.ZS, logoSmall: logosSmall.ZS},
    ZT: {logo: logos.ZT, logoSmall: logosSmall.ZT},
    ZU: {logo: logos.ZU, logoSmall: logosSmall.ZU},
    ZV: {logo: logos.ZV, logoSmall: logosSmall.ZV},
    ZW: {logo: logos.ZW, logoSmall: logosSmall.ZW},
    ZX: {logo: logos.ZX, logoSmall: logosSmall.ZX},
    ZY: {logo: logos.ZY, logoSmall: logosSmall.ZY},
};



// WEBPACK FOOTER //
// ./src/app/modules/flights/flights-suppliers.js